var map = {
	"./anadolu-isuzu.png": 5569,
	"./beiersdorf.png": 6739,
	"./bosch.png": 4594,
	"./cci.png": 3851,
	"./cimsa.png": 9441,
	"./colgate.png": 2898,
	"./danone.png": 4022,
	"./ford-otosan.png": 7460,
	"./mercedes-benz.png": 4316,
	"./migros.png": 2324,
	"./nestle.png": 5054,
	"./oyak-renault.png": 1819,
	"./sisecam1.png": 2760,
	"./sisecam2.png": 8309,
	"./turk-telekom.png": 9454,
	"./turkish-aerospace.png": 1612,
	"./unilever.png": 5282,
	"./vestel.png": 4208
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8644;